<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<form [formGroup]="formGroup" class="edit-option" cdkDrag>
  <mat-icon class="drag-icon" cdkDragHandle>drag_indicator</mat-icon>

  <mat-icon class="option-icon">
    {{ type === Cardinality.SELECT_ONE ? 'radio_button_unchecked' : 'check_box_outline_blank'}}
  </mat-icon>

  <mat-form-field class="label-option" [hideRequiredMarker]="true">
    <input
      #optionInput
      matInput
      formControlName="label"
      autocomplete="off"
      (blur)="onLabelBlur()"
      [placeholder]="'Option ' + ((index ?? 0) + 1)"
      required
    />

    <mat-error *ngIf="labelControl.touched && labelControl.invalid">
      <ng-container
        *ngIf="labelControl.getError('required')"
        i18n="@@app.controls.errors.requiredOptionText"
        >Option text is required</ng-container
      >
    </mat-error>
  </mat-form-field>

  <div class="delete-button-container">
    <button
      *ngIf="index"
      mat-icon-button
      (click)="onDeleteOption(index)"
      matTooltip="Delete Option"
      type="button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</form>
